/**
* image card slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the image card slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'image-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const $progressBar = $( '.image-card-slider__progress' );

      $( '.image-card-slider__slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
        const calc = ( ( nextSlide ) / ( slick.slideCount-1 ) ) * 100;

        $progressBar
            .css( 'width', calc + '%' );
      } );

      $( '.image-card-slider__slider' ).slick( {
        prevArrow: '.image-card-slider .btn-prev',
        nextArrow: '.image-card-slider .btn-next',
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      } );

      document.querySelectorAll( '.image-card-slider' ).forEach( ( el ) => {
        const leavesContainer = el.querySelector( '.image-card-slider__leaves' );
        let leaves;
        const path = 'lr.json';

        if ( leavesContainer ) {
          leaves = lottie.loadAnimation( {
            container: leavesContainer,
            renderer: 'svg',
            name: 'lr',
            loop: false,
            autoplay: false,
            path: site_info.url+'/wp-content/themes/liv-wellness/assets/lottie/lr/'+path,
            rendererSettings: {
              viewBoxOnly: true,
            },
          } );

          ScrollTrigger.create( {
            trigger: el,
            // markers: true,
            start: 'top 75%',
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                leaves.play();
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              leaves.play();
            },
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-card-slider', COMPONENT );
} )( app );
